import React, { useState, useEffect } from "react";
import ProjectsDesktop from "../Desktop/ProjectsDesktop";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import data from "../database";
import ProjectsMobile from "../Mobile/ProjectsMobile";
// import { skills } from "../database";

const AboutMe = () => {
  const [isMobile, setIsMobile] = useState(false);
  data.sort((a, b) => b.id - a.id);

  const displayWorks = data.map((each) => (
    <ProjectsDesktop
      key={each.id}
      img={each.img}
      id={each.id}
      display={each.display}
      header={each.descriptionOne}
      subHeader={each.descriptionTwo}
      language={each.language}
    />
  ));

  const displayWorksMobile = data.map((each) => (
    <ProjectsMobile
      key={each.id}
      img={each.img}
      id={each.id}
      display={each.display}
      header={each.descriptionOne}
      subHeader={each.descriptionTwo}
      language={each.language}
    />
  ));

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the screen size breakpoint as needed
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial screen size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      {isMobile ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "2%",
              marginLeft: "3%",
              height: "3%",
            }}
          >
            <Sidebar />

            <div style={{ width: "90%", marginTop: "3%" }}>
              <Navbar />
              <h1 style={{ width: "90%", margin: "3% auto 0 auto" }}>
                <span style={{ color: "#C778DD" }}>/</span>
                <span style={{ color: "white", fontWeight: "bolder" }}>
                  Projects
                </span>
              </h1>
              <h5
                style={{
                  width: "90%",
                  margin: "3% auto 0 auto",
                  color: "white",
                }}
              >
                List of some of my projects
              </h5>

              <h1 style={{ width: "90%", margin: "3% auto 0 auto" }}>
                <span style={{ color: "#C778DD" }}>#</span>
                <span style={{ color: "white" }}>Complete Apps</span>
              </h1>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "3%",
                  width: "90%",
                  margin: "4% auto 0 auto",
                }}
              >
                {displayWorksMobile}
                {/* {displayWorks} */}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "2%",
              marginLeft: "3%",
              height: "3%",
            }}
          >
            <Sidebar />

            <div style={{ display: "block", width: "90%" }}>
              <Navbar />
              <h1 style={{ width: "90%", margin: "3% auto 0 auto" }}>
                <span style={{ color: "#C778DD" }}>/</span>
                <span style={{ color: "white", fontWeight: "bolder" }}>
                  Projects
                </span>
              </h1>
              <h5 style={{ width: "90%", margin: "1% auto 0 auto" }}>
                <span style={{ color: "white", fontWeight: "bolder" }}>
                  List of some my projects
                </span>
              </h5>

              <h1 style={{ width: "90%", margin: "3%    auto 0 auto" }}>
                <span style={{ color: "#C778DD" }}>#</span>
                <span style={{ color: "white", fontWeight: "bolder" }}>
                  Complete Apps
                </span>
              </h1>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "3%",
                  marginTop: "3%",
                  width: "90%",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {displayWorks}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AboutMe;
